import React from "react";
import Link from "next/link";
import type { NavigationItem } from "./types";

interface NavItemLinkProps {
  item: Pick<NavigationItem, "href" | "fullPageLoad">;
  className?: string;
  onClick?: () => void;
  "aria-current"?: "page";
  children: React.ReactNode;
}

/**
 * The anchor every nav renderer uses for an item. A `fullPageLoad` item (the
 * credential vault, issue #3278) is a plain `<a>` so the browser loads a fresh
 * document at that URL — the vault's CSP nonce and COOP are headers of THAT
 * document; everything else keeps Next's client-side `<Link>`.
 */
export function NavItemLink({ item, className, onClick, children, ...rest }: NavItemLinkProps) {
  if (item.fullPageLoad) {
    return (
      <a href={item.href} className={className} onClick={onClick} aria-current={rest["aria-current"]} data-full-page-load="">
        {children}
      </a>
    );
  }
  return (
    <Link href={item.href} className={className} onClick={onClick} aria-current={rest["aria-current"]}>
      {children}
    </Link>
  );
}
